import { createStore } from 'zustand/vanilla';
/** @import { StoreApi } from 'zustand/vanilla' */
/**
 * @typedef {Object} MapLayerDockState
 * @property {boolean} isOpen
 * @property {string | null} activeTabKey
 * @property {string} activeMapBaseKey
 * @property {Record<string, MapBase> | null} firebaseMapBaseConfigs
 * @property {boolean} isLoading
 * @property {string | null} error
 * @property {(isOpen: boolean) => void} setIsOpen
 * @property {(activeTabKey: string | null) => void} setActiveTabKey
 * @property {(activeMapBaseKey: string) => void} setActiveMapBaseKey
 * @property {(firebaseMapBaseConfigs: Record<string, MapBase>) => void} setFirebaseMapBaseConfigs
 * @property {(isLoading: boolean) => void} setIsLoading
 * @property {(error: string | null) => void} setError
 */
/** @typedef {StoreApi<MapLayerDockState>} MapLayerDockStore */

/** @import {MapBase} from '../default-map-bases.js' */
import { DEFAULT_CESIUM_MAP_BASE_KEY } from '../default-map-bases.js';

/** @returns {MapLayerDockStore} */
export function createMapLayerDockStore() {
  return createStore((set, get) => ({
    // Initial state values
    isOpen: false,
    activeTabKey: null,
    activeMapBaseKey: DEFAULT_CESIUM_MAP_BASE_KEY,
    firebaseMapBaseConfigs: null,
    isLoading: false,
    error: null,

    // State setters
    setIsOpen: (isOpen) => set({ isOpen }),
    setActiveTabKey: (activeTabKey) => set({ activeTabKey }),
    setActiveMapBaseKey: (activeMapBaseKey) => set({ activeMapBaseKey }),
    setFirebaseMapBaseConfigs: (firebaseMapBaseConfigs) => set({ firebaseMapBaseConfigs }),
    setIsLoading: (isLoading) => set({ isLoading }),
    setError: (error) => set({ error })
  }));
}
